module.exports = __webpack_public_path__ + "img/Structures.04843068.png";